import { getTemplateData } from '/providers/templates-api'
import _ from "lodash"

export default async ({ apiSource, apiKey, templateId }) => {
  try {
    const data = await getTemplateData({ apiSource, apiKey, templateId })
    // TODO handle error
    const template = data.template
    let variables = template.variables

    // Our internal type. Enables us to differentiate between different uses for the same pass type. 
    const smartixPassType = template.pass_type_id

    const applePassType = template.apple_pass_type
    const appleModel = template.apple_model
    const appleTemplate = template.apple_template
    const appleSubType = template.apple_sub_type

    const googlePassType = template.google_pass_type
    const googleClass = template.google_class
    const googleObject = template.google_object
    const googleSubType = template.google_sub_type

    const templateName = template.name
    const templateDescription = template.description
    const templateClientId = Number(template.client_id)
    const isManagedPassTemplate = template.managed_pass_template === 1
    const passGroupId = template.group_id
    const scannerData = template.scanner_data
    const variableCatalog = template.variable_catalog

    const metaData = {
      name: template.name,
      expire_on_zero_balance: template.expire_on_zero_balance === 1,
      retention_period : template.retention_period,
      max_notifications : template.max_notifications
    }

    return { isManagedPassTemplate, smartixPassType, appleTemplate, googleObject, appleModel, googleClass, applePassType, googlePassType, appleSubType, googleSubType, templateName, templateDescription, templateClientId, metaData, variables, scannerData, passGroupId, variableCatalog, variablesCatalog: variableCatalog }
  }
  catch (err) {
    throw err
  }
} 
